/* HH Pakkabyggir – virkni (Claude, 2026-10-22). Hlaðið úr sections/hh-pakkar.liquid.
   Hver valinn kassi fer í körfu sem PAKKA-ÚTGÁFA af sínu bragði (t.d. „Hydration pakki – Mixed Berries“
   á 1.633 kr.) og glerbrúsinn sem „Glerbrúsi – gjöf með pakka“ (0 kr.). Pakka-útgáfurnar eru Shopify-bundle
   með grunnvöruna sem íhlut, svo lagerinn lækkar á réttri bragðtegund og Dropp fær rétt SKU.
   Engir afsláttarkóðar. Línurnar bera _pakki (karfan sýnir pakkann sem eina línu). */
(function () {
  function money(cents) {
    var n = Math.round(cents / 100), str = String(Math.abs(n)), out = '';
    while (str.length > 3) { out = '.' + str.slice(-3) + out; str = str.slice(0, -3); }
    return (n < 0 ? '−' : '') + str + out + ' kr.';
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }

  function init(el) {
    if (!el || el.dataset.ready) return;
    var data;
    try { data = JSON.parse(el.querySelector('[data-hhp-data]').textContent); } catch (e) { return; }
    var bundles = data.bundles || [];
    if (!bundles.length) return;
    el.dataset.ready = '1';

    var CATS = ['hydration', 'kreatin', 'energy', 'kids'];
    var items = data.items || [];
    var gift = data.gift || { label: '', items: [] };
    var byId = {}, catLabel = {}, giftById = {};
    items.forEach(function (it) { byId[it.id] = it; catLabel[it.cat] = it.catLabel; });
    gift.items.forEach(function (g) { giftById[g.id] = g; });

    var tabs = Array.prototype.slice.call(el.querySelectorAll('[data-hhp-tab]'));
    var picker = el.querySelector('[data-hhp-picker]');
    var giftBox = el.querySelector('[data-hhp-gift]');
    var totalsEl = el.querySelector('.hhp__totals');
    // eins og í áskriftinni: gjafakortið kemur á eftir samtölunni
    if (giftBox && totalsEl) totalsEl.parentNode.insertBefore(giftBox, totalsEl.nextSibling);
    var ctas = Array.prototype.slice.call(el.querySelectorAll('[data-hhp-cta]'));
    var hint = el.querySelector('[data-hhp-hint]');
    var bundle = null, qty = {}, giftId = null;

    function q(sel) { return el.querySelector(sel); }
    function total() { var t = 0; for (var k in qty) t += qty[k]; return t; }
    function catTotal(cat) { var t = 0; for (var k in qty) if (byId[k] && byId[k].cat === cat) t += qty[k]; return t; }
    function allowedCats() {
      if (bundle.mode === 'free') return CATS.filter(function (c) { return catLabel[c]; });
      return CATS.filter(function (c) { return (bundle.req[c] || 0) > 0 && catLabel[c]; });
    }
    function needed() {
      if (bundle.mode === 'free') return bundle.min;
      var n = 0; CATS.forEach(function (c) { n += bundle.req[c] || 0; }); return n;
    }
    function fixedPrice() { return bundle.mode === 'fixed' && bundle.price > 0; }
    function hasGift() { return bundle.gift && gift.items.some(function (g) { return g.available; }); }
    function boxesDone() {
      if (bundle.mode === 'free') return total() >= bundle.min && total() <= bundle.max;
      return CATS.every(function (c) { return catTotal(c) === (bundle.req[c] || 0); });
    }
    function complete() { return boxesDone() && (!hasGift() || !!giftId); }
    function tier() {
      if (bundle.mode === 'free' && bundle.code2 && bundle.min2 && total() >= bundle.min2) return { code: bundle.code2, pct: bundle.pct2 };
      return { code: bundle.code, pct: bundle.pct };
    }
    function isAvail(it) {
      if (!it.available) return false;
      if (bundle && bundle.variants && bundle.variants.length) { var pv = pakkiVariant(it); return !!(pv && pv.available); }
      return true;
    }
    function canAdd(it) {
      if (!isAvail(it)) return false;
      if (bundle.mode === 'free') return total() < bundle.max;
      return catTotal(it.cat) < (bundle.req[it.cat] || 0);
    }

    function select(slug, push) {
      bundle = bundles.filter(function (b) { return b.slug === slug; })[0] || bundles[0];
      qty = {};
      if (!giftId || !giftById[giftId] || !giftById[giftId].available) {
        var firstGift = gift.items.filter(function (g) { return g.available; })[0];
        giftId = firstGift ? firstGift.id : null;
      }
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.hhpTab === bundle.slug ? 'true' : 'false'); });
      if (push) {
        try { var u = new URL(window.location.href); u.searchParams.set('pakki', bundle.slug); history.replaceState(null, '', u.toString()); } catch (e) {}
      }
      if (hint) hint.classList.remove('is-error');
      renderPicker();
      update();
    }

    function renderPicker() {
      var html = '';
      allowedCats().forEach(function (cat) {
        html += '<div class="hhp__group"><div class="hhp__group-head"><h2 class="hhp__group-title">' + esc(catLabel[cat]) + '</h2>' +
          '<span class="hhp__group-count" data-count="' + cat + '"></span></div><div class="hhp__grid">';
        items.filter(function (it) { return it.cat === cat; }).forEach(function (it) {
          html += '<div class="hhp__card">' +
            (isAvail(it) ? '' : '<span class="hhp__soldout">Uppselt</span>') +
            '<div class="hhp__media">' + (it.img ? '<img src="' + esc(it.img) + '" alt="' + esc(it.catLabel + ' ' + it.name) + '" width="360" height="360">' : '') + '</div>' +
            '<p class="hhp__name">' + esc(it.name) + '</p>' +
            '<p class="hhp__meta">' + esc(it.size) + (fixedPrice() ? '' : ' · ' + money(it.price)) + '</p>' +
            '<div class="hhp__ctrl" data-ctrl="' + it.id + '"></div></div>';
        });
        html += '</div></div>';
      });
      picker.innerHTML = html;
    }

    function renderCtrl(it) {
      var box = picker.querySelector('[data-ctrl="' + it.id + '"]');
      if (!box) return;
      var n = qty[it.id] || 0;
      box.parentNode.classList.toggle('has-qty', n > 0);
      if (!isAvail(it)) { box.innerHTML = '<button type="button" class="hhp__add" disabled>Uppselt</button>'; return; }
      if (!n) {
        box.innerHTML = '<button type="button" class="hhp__add" data-plus="' + it.id + '"' + (canAdd(it) ? '' : ' disabled') + '><span class="hhp__plus" aria-hidden="true">+</span>Bæta við</button>';
      } else {
        box.innerHTML = '<div class="hhp__step"><button type="button" data-minus="' + it.id + '" aria-label="Fækka ' + esc(it.name) + '">−</button>' +
          '<output>' + n + '</output><button type="button" data-plus="' + it.id + '" aria-label="Bæta við ' + esc(it.name) + '"' + (canAdd(it) ? '' : ' disabled') + '>+</button></div>';
      }
    }

    function renderGift() {
      if (!giftBox) return;
      if (!hasGift()) { giftBox.hidden = true; giftBox.innerHTML = ''; return; }
      giftBox.hidden = false;
      var g = giftById[giftId] || gift.items[0];
      var html = (g && g.img ? '<img src="' + esc(g.img) + '" alt="" width="96" height="96">' : '<span></span>') +
        '<div><span class="hhp__gift-kicker">🎁 Frí gjöf</span><span class="hhp__gift-name">' + esc(gift.label) + '</span><span class="hhp__gift-sub">Fylgir pakkanum</span></div>' +
        '<span class="hhp__gift-price"><s>' + money(g ? g.price : 0) + '</s><strong>FRÍTT</strong></span>';
      var avail = gift.items.filter(function (c) { return c.available; });
      if (avail.length > 1) {
        html += '<div class="hhp__gift-colors" role="group" aria-label="Veldu lit">' + avail.map(function (c) {
          return '<button type="button" data-gift="' + c.id + '" aria-pressed="' + (c.id === giftId) + '">' + esc(c.name) + '</button>';
        }).join('') + '</div>';
      }
      giftBox.innerHTML = html;
    }

    function update() {
      var cats = allowedCats();
      items.forEach(function (it) { if (cats.indexOf(it.cat) > -1) renderCtrl(it); });
      renderGift();
      cats.forEach(function (cat) {
        var c = picker.querySelector('[data-count="' + cat + '"]');
        if (!c) return;
        var ct = catTotal(cat);
        if (bundle.mode === 'free') { c.textContent = ct + ' valin'; c.style.display = ct ? '' : 'none'; c.classList.remove('is-done'); }
        else { var r = bundle.req[cat]; c.textContent = ct + ' / ' + r; c.classList.toggle('is-done', ct === r); }
      });

      var t = total(), need = needed(), tr = tier(), orig = 0, lines = '', slots = '';
      Object.keys(qty).forEach(function (id) {
        var it = byId[id], n = qty[id];
        if (!it || !n) return;
        orig += it.price * n;
        lines += '<li><span>' + n + '× ' + esc(it.catLabel) + ' – ' + esc(it.name) + '</span>' + (fixedPrice() ? '' : '<span>' + money(it.price * n) + '</span>') + '</li>';
        for (var i = 0; i < n; i++) slots += '<span class="hhp__slot is-filled">' + (it.img ? '<img src="' + esc(it.img) + '" alt="">' : '') + '</span>';
      });
      var slotCount = bundle.mode === 'free' ? Math.max(need, t) : need;
      for (var j = t; j < slotCount; j++) slots += '<span class="hhp__slot"></span>';

      var done = complete(), before, now, discLabel;
      if (fixedPrice()) {
        before = bundle.compare > bundle.price ? bundle.compare : 0;
        now = bundle.price;
        discLabel = before ? 'Þú sparar ' + Math.round((before - now) / before * 100) + '%' : 'Pakkaverð';
      } else {
        var disc = boxesDone() ? Math.round(orig * tr.pct / 100) : 0;
        before = orig; now = orig - disc;
        discLabel = 'Pakkaafsláttur ' + tr.pct + '%';
      }
      q('[data-hhp-sum-title]').textContent = bundle.title;
      q('[data-hhp-progress]').innerHTML = slots;
      q('[data-hhp-lines]').innerHTML = (t ? lines : '') || '<li class="is-empty">Veldu kassa til að byrja</li>';
      q('[data-hhp-orig-label]').textContent = fixedPrice() ? 'Verð áður' : 'Verð';
      q('[data-hhp-orig]').textContent = before ? money(before) : '–';
      q('[data-hhp-disc-label]').textContent = discLabel;
      q('[data-hhp-disc]').textContent = before > now ? money(now - before) : '–';
      q('[data-hhp-total]').textContent = money(now);
      q('[data-hhp-bar-total]').textContent = money(now);
      q('[data-hhp-bar-count]').textContent = bundle.mode === 'free' ? t + ' kassar' : t + ' / ' + need + ' kassar';

      var msg;
      if (!boxesDone()) {
        msg = bundle.mode === 'free'
          ? (t < bundle.min ? 'Veldu ' + (bundle.min - t) + ' kassa í viðbót' : 'Hámark ' + bundle.max + ' kassar')
          : 'Veldu ' + (need - t) + ' kassa í viðbót';
      } else if (!done) {
        msg = 'Veldu glerbrúsa';
      } else if (bundle.mode === 'free' && bundle.code2 && t < bundle.min2) {
        msg = 'Bættu við ' + (bundle.min2 - t) + ' kassa og fáðu ' + bundle.pct2 + '% afslátt';
      } else {
        msg = 'Pakkinn er klár' + (hasGift() ? ' – glerbrúsinn fylgir með' : '');
      }
      if (hint && !hint.classList.contains('is-error')) hint.textContent = msg;
      ctas.forEach(function (b) { b.disabled = !done; });
    }

    picker.addEventListener('click', function (e) {
      var plus = e.target.closest('[data-plus]'), minus = e.target.closest('[data-minus]');
      if (!plus && !minus) return;
      if (hint) hint.classList.remove('is-error');
      if (plus) {
        var it = byId[plus.dataset.plus];
        if (it && canAdd(it)) { qty[it.id] = (qty[it.id] || 0) + 1; update(); }
      } else {
        var id = minus.dataset.minus;
        if (qty[id]) { qty[id] -= 1; if (!qty[id]) delete qty[id]; update(); }
      }
    });

    if (giftBox) giftBox.addEventListener('click', function (e) {
      var gb = e.target.closest('[data-gift]');
      if (!gb) return;
      var gid = Number(gb.dataset.gift);
      if (giftById[gid] && giftById[gid].available) { giftId = gid; update(); }
    });

    tabs.forEach(function (t) { t.addEventListener('click', function () { select(t.dataset.hhpTab, true); }); });

    // Pakka-útgáfa hvers kassa: sama bragð, flokksforskeyti í Ultimate („Hydration – Mixed Berries“)
    var PREFIX = { hydration: 'Hydration', kreatin: 'Kreatín', energy: 'Energy', kids: 'Kids' };
    function norm(t) { return String(t || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
    function pakkiVariant(it) {
      var list = (bundle && bundle.variants) || [];
      var a = norm(it.name), b = norm((PREFIX[it.cat] || '') + ' – ' + it.name);
      for (var i = 0; i < list.length; i++) {
        var n = norm(list[i].name);
        if (n === a || n === b) return list[i];
      }
      return null;
    }

    ctas.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!complete()) return;
        var tr = tier(), lines = [], missing = [];
        var usePakki = bundle.variants && bundle.variants.length;
        Object.keys(qty).filter(function (id) { return qty[id] > 0; }).forEach(function (id) {
          var it = byId[id], pv = usePakki ? pakkiVariant(it) : null;
          if (usePakki && !pv) { missing.push(it.name); return; }
          lines.push({ id: pv ? pv.id : Number(id), quantity: qty[id], properties: { _pakki: bundle.title } });
        });
        if (missing.length) {
          if (hint) { hint.classList.add('is-error'); hint.textContent = 'Ekki tókst að setja ' + missing.join(', ') + ' í pakkann – hafðu samband við okkur.'; }
          return;
        }
        if (hasGift() && giftId) {
          var giftLineId = usePakki && data.giftPakki ? data.giftPakki : giftId;
          lines.push({ id: giftLineId, quantity: 1, properties: { _pakki: bundle.title, _gjof: 'Frí gjöf' } });
        }
        ctas.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); });
        fetch(data.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: lines }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () {
            var root = data.root || '/';
            if (root.charAt(root.length - 1) !== '/') root += '/';
            window.location.href = (!usePakki && tr.code)
              ? root + 'discount/' + encodeURIComponent(tr.code) + '?redirect=' + encodeURIComponent(data.cartUrl)
              : data.cartUrl;
          })
          .catch(function (err) {
            ctas.forEach(function (b) { b.classList.remove('is-loading'); });
            if (hint) { hint.classList.add('is-error'); hint.textContent = (err && (err.description || err.message)) || 'Eitthvað fór úrskeiðis – reyndu aftur.'; }
            update();
          });
      });
    });

    var start = '';
    try { start = new URL(window.location.href).searchParams.get('pakki') || ''; } catch (e) {}
    select(start, false);
  }

  function boot(root) { Array.prototype.forEach.call((root || document).querySelectorAll('[data-hhp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest && e.target.closest('[data-hhp-tab]');
    if (tab) tab.click();
  });
})();
